 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		1: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~intl-relativetimeformat~polyfills","2":"lang_af","3":"lang_ar","4":"lang_be","5":"lang_bg","6":"lang_bs","7":"lang_ca","8":"lang_cs","9":"lang_da","10":"lang_de","11":"lang_el","12":"lang_es","13":"lang_et","14":"lang_fi","15":"lang_fil","16":"lang_fr","17":"lang_he","18":"lang_hi","19":"lang_hr","20":"lang_hu","21":"lang_id","22":"lang_is","23":"lang_it","24":"lang_ja","25":"lang_ka","26":"lang_kk","27":"lang_ko","28":"lang_ky","29":"lang_lt","30":"lang_lv","31":"lang_nl","32":"lang_no","33":"lang_pa","34":"lang_pl","35":"lang_pt","36":"lang_pt_br","37":"lang_ro","38":"lang_ru","39":"lang_sk","40":"lang_sl","41":"lang_sq","42":"lang_sr","43":"lang_sr_me","44":"lang_sv","45":"lang_sw","46":"lang_th","47":"lang_tr","48":"lang_tw","49":"lang_uk","50":"lang_ur","51":"lang_vi","52":"lang_zh_cn","53":"lang_zh_tw","54":"locale_ak","55":"locale_ar","56":"locale_be","57":"locale_bg","58":"locale_bs","59":"locale_ca","60":"locale_cs","61":"locale_da","62":"locale_de","63":"locale_el","64":"locale_en","65":"locale_es","66":"locale_et","67":"locale_fi","68":"locale_fil","69":"locale_fr","70":"locale_he","71":"locale_hi","72":"locale_hr","73":"locale_hu","74":"locale_id","75":"locale_is","76":"locale_it","77":"locale_ja","78":"locale_ka","79":"locale_kk","80":"locale_ko","81":"locale_ky","82":"locale_lt","83":"locale_lv","84":"locale_nl","85":"locale_pa","86":"locale_pl","87":"locale_pt","88":"locale_ro","89":"locale_ru","90":"locale_sk","91":"locale_sl","92":"locale_sq","93":"locale_sr","94":"locale_sr_cyrl_me","95":"locale_sv","96":"locale_sw","97":"locale_th","98":"locale_tr","99":"locale_uk","100":"locale_ur","101":"locale_vi","102":"locale_zh","103":"loclae_af","104":"polyfills","105":"pubnub","107":"vendors~polyfills","108":"vendors~pubnub"}[chunkId]||chunkId) + "." + {"0":"f9d893de880826f24551","2":"adb53493ba6969bae8de","3":"3a21edaea7363435be1f","4":"7976bf88adce513247bd","5":"9b086b7b93ff2938ceb3","6":"bd67ff93d01d8d7de2b0","7":"84cec3cea45e3328267a","8":"1873f744ebd5c0012cd9","9":"3dfea2cbf82e27a41205","10":"a4053c1c528938f21f4d","11":"af8cbc0cded78fa8f88a","12":"27ce6965cdcc50c633eb","13":"d07f7039a7c50c64ac00","14":"7fc2f39e63e42ffba46f","15":"c452ec8305895b6df07e","16":"7c5b15936af6c4269459","17":"855a7f1e9252af79d823","18":"ae973d341a2718807fe8","19":"c70a5352328600761512","20":"aca2b7109b74928dc987","21":"4b8d22c0e5764ec58799","22":"c9b52d9940fc6e2f3256","23":"2f55315c43ea8d4d4d67","24":"835b48d0a4a307bc395c","25":"1a5131d7b0e011054d00","26":"6fb8c54f7f027a41d4ae","27":"7eed813a422b2ba7f252","28":"6b0ba065e7af8496e88a","29":"ade7206872b5f5db48c6","30":"ab00bca8acfd6146306e","31":"8b84cca8daff1a74f2ea","32":"79a36459c9f8a41968b8","33":"2637d9d2661ad80f0ac4","34":"719d8b957ce930facc08","35":"f972e59dae4bbc02ae1b","36":"e574c14d6591030ba6b8","37":"696428134bf1d0f881f7","38":"66d8cf00755b92a15757","39":"90bcc3626fe45262df32","40":"bd9df0bb2817594e15fb","41":"892ef5a124da7e32e5c0","42":"378eac98d2a8cfa22fdc","43":"4cdc39710b9470615cd5","44":"ac48dafc122e9e9dc29b","45":"945f9dda786f536047c3","46":"53282c7bce9a17126401","47":"35f22f3418ac63cd3a3d","48":"5a2343f61fb380b3b889","49":"4a2157521f5f86eaeb51","50":"c15db74f1d6dfd2f3e1e","51":"5f59cf682243fe8ba560","52":"5dd3a6a51e5c03de93e2","53":"0ae3db7a30783c128a24","54":"884244e01c4c9439a04b","55":"a67177339486161c8c19","56":"0af0b21deac1ac4bda49","57":"db7469f9c2628dda20b6","58":"50fd952716abd10cfdd8","59":"a2cae0bbc43fd89921ee","60":"abf14a44044c8968506c","61":"23b98e58de1d7d5ca52e","62":"4091726c9d3d9912a78d","63":"ff0e526fc5f6b316d699","64":"b425afc014701d4f7e31","65":"2a58b6e927e2e5d6515b","66":"da96da154c315475a4a2","67":"c9c37b5288added746e2","68":"f545a5f78aeb6c05b520","69":"b087bf61f5e2f02154fd","70":"d031f37098d48f32bf56","71":"ef74c405f73d1345ea18","72":"c8070b95057a70371339","73":"93ef8c8d67578d40160d","74":"53807ab3399f6c996121","75":"f6c0fc692210ea2c0d2a","76":"4f6aabcfd970ab811455","77":"350f0b84758aea987727","78":"f45254917a13a068a19f","79":"38304169cf14c528bbf9","80":"4d350f0ef0948c656c9f","81":"6eca0e8b90c8daa33cff","82":"d7caeda3c0d70106f545","83":"be2b62cf1bb72359b9e8","84":"c3a3c4e695a6e169870a","85":"3cf8d19735d25274deda","86":"d316e08d1a243ec57b7b","87":"7720d344fa0a6b6638bd","88":"032d1239e0f447355f51","89":"7b061e07a3e34a729514","90":"78345698222bf2099af1","91":"0334509e33ccebb3e7bc","92":"887699b763c6827aaaf8","93":"ed99916ebd49ccfe61bc","94":"8405b6beffd1e78b55cc","95":"5b4bea47fe8cdfca842e","96":"b3880a29cdd2e470c012","97":"20712d29f3c488c19202","98":"48447f14ce93f1875f7d","99":"bd52c2e3d86327884703","100":"a76668e86250b2d77f7d","101":"9eaed0414dbb9407a33e","102":"161a82848601ad751f54","103":"41793143c55ebdd9f7b7","104":"6f38dcb5c1a6f1a5caaa","105":"03fb357312ee98dec413","107":"249b86289ea5b480530e","108":"8cd88b1dc524ab4021d7"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.kustomerapp.com/chat-web/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["kustomer_chat_webpackJsonp"] = window["kustomer_chat_webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 80);
